<template>
  <div class="loginview">


    <div class="columns">
      <div class="column is-third">
        <HelloWorld style="color:green; font-weight: bold" msg="APPKA"/>
        <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
      </div>

      <div class="column is-third">
        <div style="height: 4em"></div>

        <HelloWorld msg="PRIHLÁSENIE" />

        <Login/>

      </div>

      <div class="column is-third">
        <div class="buttons">
          <a class="button is-primary" @click="navigateTo('/register')" >
            <strong>REGISTRÁCIA</strong>
          </a>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/auth/Login.vue'
// import Register from '@/components/auth/Register.vue'
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'loginview',
  components: {
    HelloWorld,
    Login,

  },
  methods: {
    navigateTo (routepath) {
      // window.alert(this.msg)
      this.$router.push({path: routepath})
    }
  }
}
</script>
